import {
  MARK_NOTIFICATION_AS_READ_FAILED,
  MARK_NOTIFICATION_AS_READ,
  MARK_NOTIFICATION_AS_READ_SUCCESS,
  GET_NOTIFICATIONS_BY_USER,
  GET_NOTIFICATIONS_BY_USER_SUCCESS,
  GET_NOTIFICATIONS_BY_USER_FAILED,
  OPEN_NOTIFICATION_MODAL,
  CLOSE_NOTIFICATION_MODAL,
  CHECK_NEW_NOTIFICATIONS,
} from './constants';

const initialState = {
  openModal: false,
  notifications: [],
  areNewNotifications: false,
  error: null,
  loading: false,
};

const notificationReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case GET_NOTIFICATIONS_BY_USER:
      return {
        ...state,
        loading: true,
      };
    case GET_NOTIFICATIONS_BY_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        notifications: action.payload.notifications,
      };
    case GET_NOTIFICATIONS_BY_USER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case MARK_NOTIFICATION_AS_READ:
      return {
        ...state,
        loading: true,
      };
    case MARK_NOTIFICATION_AS_READ_SUCCESS:
      return {
        ...state,
        loading: false,
        notifications: state.notifications.map((notification) => ({
          ...notification,
          read: action.payload.notification.id === notification.id ? true : notification.read,
        })),
      };
    case MARK_NOTIFICATION_AS_READ_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case OPEN_NOTIFICATION_MODAL:
      return {
        ...state,
        openModal: true,
      };
    case CLOSE_NOTIFICATION_MODAL:
      return {
        ...state,
        openModal: false,
      };
    case CHECK_NEW_NOTIFICATIONS:
      return {
        ...state,
        areNewNotifications: state.notifications.some((notification) => !notification.read),
      };
    default:
      return state;
  }
};

export default notificationReducer;
